import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Default heltar-branded Switch className */
export const SWITCH_HELTAR_CLASS =
  '!switch-heltar !data-[state=checked]:bg-[var(--heltar-brand-primary)]' as const;

/** Switch className with a custom checked color */
export const switchHeltarColorClass = (color: string): string =>
  `!switch-heltar !data-[state=checked]:bg-${color}`;
